import { render } from "./Footer.vue?vue&type=template&id=3122ed34&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3122ed34&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3122ed34"]])

export default __exports__